import { Admin } from "./admin"

export const AdminContainer = () => {
    return <Admin />
}